import { parseFullName, renderTextLineClamp } from 'helpers';
import { ClientsListItem } from 'modules/client/clients/types';

export const renderName = (item: ClientsListItem) => {
  const name = parseFullName(item);
  return renderTextLineClamp(name);
};
